<template>
  <input
    v-model="text"
    :type="type"
    :name="name"
    :placeholder="placeholder"
    :disabled="disabled"
    :class="{'is-error': error}"
    :maxlength="maxlength"
    class="form-input"
  />
</template>

<script>

export default {
  name: 'form-input',
  props: {
    modelValue: { type: [String, Number], require: true },
    type: { type: String, require: true },
    name: { type: String, require: true },
    placeholder: { type: String, require: false },
    maxlength: { type: String, require: false },
    disabled: { type: Boolean, require: false, 'default':false },
    error: { type: Boolean, require: false, 'default':false }
  },
  emits: ['update:modelValue'],
  computed: {
    text: {
      get() {
        return this.modelValue
      },
      set(newValue) {
        this.$emit('update:modelValue', newValue)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/variables";
.form-input {
  height: 40px;
  background-color: $white-01;
  border-radius: 5px;
  border: 1px solid $gray-line;
  font-size: 14px;
  &::placeholder {
    color: $gray-text;
		opacity: 1;
  }
  &[type="tel"],
  &[type="text"],
  &[type="number"] {
		padding-left: 10px;
		padding-right: 10px;
  }

  &[type="text"],
  &[type="number"] {
    width: 100%;
    max-width: 600px;
  }

  &:disabled {
		background-color: $gray-line;
  }
  &.is-error {
    background-color: $red-bg
  }
}
</style>
